import PetProfile from "happypaws-shared/src/Pets/models/PetProfile";
import { api } from "services/api";
import { useQuery } from "@tanstack/react-query";

export const useGetPets = () => {
  return useQuery({
    queryKey: ["pets"],
    queryFn: async () => {
      const response = await api.get<PetProfile[]>("/pets");
      return response.data;
    },
  });
};
